import React, { useState } from "react";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import DatePicker from "react-modern-calendar-datepicker";
import moment from "moment-jalaali";

const App = props => {
  const [selectedDay, setSelectedDay] = useState(null);
  function SelectedDate(e) {
    setSelectedDay(e);
    props.getDate(
      moment(`${e.year}/${e.month}/${e.day}`, "jYYYY/jM/jD HH:mm").format(
        "YYYY/MM/DD"
      )
      //   moment
      //     .from(`${e.year}/${e.month}/${e.day}`, "fa", "YYYY/MM/DD")
      //     .format("YYYY-MM-DD")
    );
  }
  // render regular HTML input element
  const renderCustomInput = ({ ref, onFocus, onBlur }) => (
    <input
      readOnly
      ref={ref} // necessary
      onFocus={onFocus} // necessary
      onBlur={onBlur} // necessary
      placeholder="از تاریخ"
      value={
        selectedDay
          ? `${selectedDay.year} / ${selectedDay.month} / ${selectedDay.day}`
          : ""
      }
      style={{
        textAlign: "right",
        padding: "3px 14px",
        border: "1px solid rgb(193, 193, 193)",
        borderRadius: "5px",
        width: "100%",
        fontFamily: "dirooz",
        fontSize: "17px",
        color: "rgb(97, 97, 97)",
        direction: "ltr"
      }}
      className="my-custom-input-class" // a styling class
    />
  );

  return (
    <DatePicker
      selectedDay={selectedDay}
      onChange={e => SelectedDate(e)}
      renderInput={renderCustomInput} // render a custom input
      shouldHighlightWeekends
      isPersian
    />
  );
};

export default App;
